export default function Milo({ className, gradient = false }: { className?: string; gradient?: boolean }) {
  const strokeColor = gradient ? "url(#milo-gradient)" : "currentColor"
  
  return (
    <svg width="357" height="359" viewBox="0 0 357 359" fill="none" className={className}>
      {gradient && (
        <defs>
          <linearGradient id="milo-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="rgb(14, 165, 233)" />
            <stop offset="50%" stopColor="rgb(99, 102, 241)" />
            <stop offset="100%" stopColor="rgb(168, 85, 247)" />
          </linearGradient>
        </defs>
      )}
      <path
        d="M225.869 145.002C224.977 141.542 223.173 138.384 220.646 135.856C218.118 133.329 214.96 131.525 211.499 130.632L150.149 114.812C149.103 114.515 148.181 113.885 147.526 113.017C146.87 112.149 146.515 111.091 146.515 110.002C146.515 108.914 146.87 107.856 147.526 106.988C148.181 106.12 149.103 105.49 150.149 105.192L211.499 89.3625C214.959 88.4706 218.116 86.6682 220.643 84.1429C223.171 81.6175 224.975 78.4614 225.869 75.0025L241.689 13.6525C241.983 12.6017 242.613 11.6759 243.483 11.0164C244.352 10.357 245.413 10 246.504 10C247.596 10 248.657 10.357 249.526 11.0164C250.396 11.6759 251.025 12.6017 251.319 13.6525L267.129 75.0025C268.022 78.4632 269.826 81.6215 272.353 84.1487C274.88 86.6759 278.039 88.4797 281.499 89.3725L342.849 105.182C343.904 105.473 344.835 106.103 345.498 106.973C346.161 107.844 346.52 108.908 346.52 110.002C346.52 111.097 346.161 112.161 345.498 113.032C344.835 113.902 343.904 114.531 342.849 114.822L281.499 130.632C278.039 131.525 274.88 133.329 272.353 135.856C269.826 138.384 268.022 141.542 267.129 145.002L251.309 206.353C251.015 207.403 250.386 208.329 249.516 208.989C248.647 209.648 247.586 210.005 246.494 210.005C245.403 210.005 244.342 209.648 243.473 208.989C242.603 208.329 241.973 207.403 241.679 206.353L225.869 145.002Z"
        stroke={strokeColor}
        strokeWidth="20"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M326.5 20V60"
        stroke={strokeColor}
        strokeWidth="20"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M346.5 40H306.5"
        stroke={strokeColor}
        strokeWidth="20"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M166.5 180V200"
        stroke={strokeColor}
        strokeWidth="20"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M176.5 190H156.5"
        stroke={strokeColor}
        strokeWidth="20"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.25 164.417V138.583C13.25 131.732 15.9717 125.161 20.8164 120.316C25.6611 115.472 32.2319 112.75 39.0833 112.75H64.9167"
        stroke={strokeColor}
        strokeWidth="25.8333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M245.752 293.58V319.413C245.752 326.265 243.03 332.836 238.185 337.68C233.341 342.525 226.77 345.247 219.918 345.247H194.085"
        stroke={strokeColor}
        strokeWidth="25.8333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M64.9167 345.247H39.0833C32.2319 345.247 25.6611 342.525 20.8164 337.68C15.9717 332.836 13.25 326.265 13.25 319.413V293.58"
        stroke={strokeColor}
        strokeWidth="25.8333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M77.835 254.83C77.835 254.83 97.21 280.663 129.502 280.663C161.793 280.663 181.168 254.83 181.168 254.83"
        stroke={strokeColor}
        strokeWidth="25.8333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M90.75 190.25H90.8875"
        stroke={strokeColor}
        strokeWidth="25.8333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.25 164.417V138.583C13.25 131.732 15.9717 125.161 20.8164 120.316C25.6611 115.472 32.2319 112.75 39.0833 112.75H64.9167"
        stroke={strokeColor}
        strokeWidth="25.8333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M245.752 293.58V319.413C245.752 326.265 243.03 332.836 238.185 337.68C233.341 342.525 226.77 345.247 219.918 345.247H194.085"
        stroke={strokeColor}
        strokeWidth="25.8333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M77.835 254.83C77.835 254.83 97.21 280.663 129.502 280.663C161.793 280.663 181.168 254.83 181.168 254.83"
        stroke={strokeColor}
        strokeWidth="25.8333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M90.75 190.25H90.8875"
        stroke={strokeColor}
        strokeWidth="25.8333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
